module.exports = __webpack_public_path__ + "static/ud_mobile_testing-8ada5477e2af9718247046a4ad21d5ad.svg";